import getApi from '../../api'
import { CreatedStatsConversation } from '../../model/StatsAssistant'

export type CreateConversationPayload = {
  agentProfile?: string
  title?: string
}

export const createConversation = (payload: CreateConversationPayload = {}) =>
  getApi().post<CreatedStatsConversation>('/stats_assistant/conversations', payload)
